import { provideIcons } from '@ng-icons/core';
import {
  heroArrowLeft,
  heroArrowPath,
  heroArrowRightOnRectangle,
  heroBars3,
  heroBookOpen,
  heroBuildingOffice2,
  heroCalendar,
  heroChartBar,
  heroCheckCircle,
  heroChevronDown,
  heroChevronLeft,
  heroChevronRight,
  heroClipboardDocumentList,
  heroClock,
  heroCog6Tooth,
  heroEllipsisHorizontal,
  heroEye,
  heroFolderOpen,
  heroInformationCircle,
  heroMagnifyingGlass,
  heroPencil,
  heroPlus,
  heroShare,
  heroTrash,
  heroUser,
  heroUserCircle,
  heroUserGroup,
  heroUsers,
  heroXCircle,
  heroXMark,
} from '@ng-icons/heroicons/outline';

export const iconsProvider = provideIcons({
  user: heroUser,
  users: heroUsers,
  bookOpen: heroBookOpen,
  buildingOffice2: heroBuildingOffice2,
  clipboardDocumentList: heroClipboardDocumentList,
  share: heroShare,
  bars3: heroBars3,
  userCircle: heroUserCircle,
  userGroup: heroUserGroup,
  chevronDown: heroChevronDown,
  chevronRight: heroChevronRight,
  chevronLeft: heroChevronLeft,
  cog6Tooth: heroCog6Tooth,
  plus: heroPlus,
  xCircle: heroXCircle,
  xMark: heroXMark,
  checkCircle: heroCheckCircle,
  informationCircle: heroInformationCircle,
  magnifyingGlass: heroMagnifyingGlass,
  arrowLeft: heroArrowLeft,
  arrowPath: heroArrowPath,
  pencil: heroPencil,
  trash: heroTrash,
  eye: heroEye,
  ellipsisHorizontal: heroEllipsisHorizontal,
  calendar: heroCalendar,
  arrowRightOnRectangle: heroArrowRightOnRectangle,
  clock: heroClock,
  chartBar: heroChartBar,
  folderOpen: heroFolderOpen,
});
